import { DateTime } from 'luxon'

export function DateFormatter({ date, format }: { date?: string | DateTime; format?: string }) {
	if (!date) {
		return null
	}

	const dateObject = date instanceof DateTime ? date : DateTime.fromISO(date)
	const isSameYear = dateObject.year === DateTime.now().year
	format ??= isSameYear ? 'd.M. HH:mm' : 'd.M.y HH:mm'

	return <>{dateObject.toFormat(format)}</>
}
